import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { isValidGuid } from '@core/validation/util/regex-validator';
import { DatadogService } from 'src/app/services/data-dog.service';
import { EmailUnsubscribeResolverResponse } from '../models/email-unsubscribe-resolver-response';

@Injectable({
  providedIn: 'root',
})
export class EmailUnsubscribeRouteResolverService {
  private datadogService = inject(DatadogService);

  resolve(route: ActivatedRouteSnapshot): EmailUnsubscribeResolverResponse {
    const customerIdParam = route.params['customerId'];
    const emailTypeIdParam = +route.params['emailTypeId'];

    const customerIdValid = isValidGuid(customerIdParam);
    const emailTypeIdValid = Number.isInteger(emailTypeIdParam) && emailTypeIdParam >= 0;

    if (!customerIdValid || !emailTypeIdParam) {
      this.datadogService.errorMessage('Invalid unsubscribe url');
    }

    return {
      isValid: customerIdValid && emailTypeIdValid,
      customerId: customerIdParam,
      emailTypeId: emailTypeIdParam,
    } as EmailUnsubscribeResolverResponse;
  }
}
